_ = require('underscore')

# enter:  13
# shift:  16
# ctrl:   17
# alt:    18
# esc:    27
# left:   37
# right:  39
# super:  91

module.exports =

  methods:

    onWindowKeyDown: (event) ->
      if event.keyCode == 27
        @.$emit('keydownEsc')
        @onKeydownEsc() if _.isFunction(@onKeydownEsc)
      else if event.keyCode == 13
        @.$emit('keydownEnter')
        @onKeydownEnter() if _.isFunction(@onKeydownEnter)
      else if event.keyCode == 16
        @.$emit('keydownShift')
        @onKeydownShift() if _.isFunction(@onKeydownShift)
      else if event.keyCode == 17
        @.$emit('keydownCtrl')
        @onKeydownCtrl() if _.isFunction(@onKeydownCtrl)
      else if event.keyCode == 18
        @.$emit('keydownAlt')
        @onKeydownAlt() if _.isFunction(@onKeydownAlt)
      else if event.keyCode == 37
        @.$emit('keydownLeft')
        @onKeydownLeft() if _.isFunction(@onKeydownLeft)
      else if event.keyCode == 39
        @.$emit('keydownRight')
        @onKeydownRight() if _.isFunction(@onKeydownRight)

    onWindowKeyUp: (event) ->
      if event.keyCode == 27
        @.$emit('keyupEsc')
        @onKeyupEsc() if _.isFunction(@onKeyupEsc)
      else if event.keyCode == 13
        @.$emit('keyupEnter')
        @onKeyupEnter() if _.isFunction(@onKeyupEnter)
      else if event.keyCode == 16
        @.$emit('keyupShift')
        @onKeyupShift() if _.isFunction(@onKeyupShift)
      else if event.keyCode == 17
        @.$emit('keyupCtrl')
        @onKeyupCtrl() if _.isFunction(@onKeyupCtrl)
      else if event.keyCode == 18
        @.$emit('keyupAlt')
        @onKeyupAlt() if _.isFunction(@onKeyupAlt)
      else if event.keyCode == 37
        @.$emit('KeyupLeft')
        @onKeyupLeft() if _.isFunction(@onKeyupLeft)
      else if event.keyCode == 39
        @.$emit('KeyupRight')
        @onKeyupRight() if _.isFunction(@onKeyupRight)

  created: ->
    window.addEventListener 'keyup', @onWindowKeyUp
    window.addEventListener 'keydown', @onWindowKeyDown

  beforeDestroy: ->
    window.removeEventListener 'keyup', @onWindowKeyUp
    window.removeEventListener 'keydown', @onWindowKeyDown


// WEBPACK FOOTER //
// ./assets/js/shared/mixins/vue/window_key_listener_mixin.coffee